<template>
  <div class="table-responsive">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <table class="table table-sm table-bordered table-condensed">
      <tbody>
      <tr v-for="field in fields.filter(f => f.sortable)" :key="fields.indexOf(field)">
        <th>
          {{field.label}}
        </th>
        <td v-if="field.formatter != null">
          {{field.formatter(movimiento[field.key])}}
        </td>
        <td v-else>
          {{movimiento[field.key]}}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "DetalleMovimiento",
  props: {
    fields: {type: Array, required: true},
    movimiento: {type: Object, required: true}
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
}
</script>

<style scoped>

</style>